module.exports = __webpack_public_path__ + "img/headphones (1).f6c4ae12.svg";